<template>
    <div class="pt-row">
        <div class="pt-dropdown">
            <BmvButton
                variant="secondary"
                size="md"
                icon="fal fa-sparkles"
                icon-right="fal fa-chevron-down"
                data-toggle="dropdown"
                aria-expanded="false"
            >
                <span class="pt-btn-lbl">{{ $t('template.name') }}</span>
            </BmvButton>
            <ul class="dropdown-menu pt-menu">
                <li class="pt-search">
                    <i class="fal fa-search"></i>
                    <input
                        class="pt-search-input"
                        :placeholder="$t('template.search')"
                        v-model="searchTemplate"
                    />
                </li>
                <li
                    v-for="(template, index) in templateList"
                    :key="`templateOption_${template.id}`"
                    class="pt-item-row"
                >
                    <div class="dropdown-item pt-item" @click="changeContent(index)">
                        {{ template.response_title }}
                    </div>
                </li>
            </ul>
        </div>

        <router-link
            to="/admin/template/create"
            class="pt-create"
            :title="$t('template.new')"
        >
            <BmvButton
                variant="success"
                size="md"
                icon="fal fa-plus"
            >
                <span class="pt-btn-lbl">{{ $t('template.new') }}</span>
            </BmvButton>
        </router-link>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BmvButton from '@/components/UI/v2/BmvButton.vue'

export default {
    name: 'PostTemplate',
    components: { BmvButton },
    data() {
        return {
            search: '',
            templateList: null
        }
    },
    methods: {
        ...mapActions('admin', ['getTemplates']),
        changeContent(index) {
            this.$emit('change-content', {
                content: this.templateList[index].response_content
            })
        },
        setTemplate(newValue) {
            let newTemplates = []
            this.templates.forEach((template) => {
                if (template.response_title.includes(newValue)) {
                    newTemplates.push(template)
                }
            })
            this.templateList = newTemplates
            this.search = newValue
        }
    },
    computed: {
        ...mapState('admin', {
            templates: (state) => state.templates
        }),
        searchTemplate: {
            get() {
                return this.search
            },
            set(newValue) {
                if (newValue.length < this.search.length) {
                    this.templateList = this.templates
                }
                this.setTemplate(newValue)
            }
        }
    },
    created() {
        this.getTemplates().then(() => {
            this.templateList = this.templates
        })
    }
}
</script>

<style scoped>
.pt-row {
    display: contents;
}

.pt-dropdown {
    position: relative;
}

.pt-create {
    text-decoration: none !important;
    display: inline-block;
}

.pt-menu {
    z-index: 1080;
    min-width: 260px;
    max-width: calc(100vw - 32px);
    max-height: 320px;
    padding: 0;
    margin-top: 6px;
    border: 1px solid var(--v2-border, #e2e8f0);
    border-radius: var(--v2-radius-lg, 12px);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
    overflow-y: auto;
    background: #fff;
}

.pt-search {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #fff;
    border-bottom: 1px solid #f1f5f9;
    list-style: none;
}

.pt-search i {
    color: #94a3b8;
    font-size: 0.85rem;
}

.pt-search-input {
    flex: 1;
    border: 0;
    outline: none;
    font-size: 0.8125rem;
    color: #0f172a;
    background: transparent;
}

.pt-search-input::placeholder {
    color: #94a3b8;
}

.pt-item-row {
    list-style: none;
    border-top: 1px solid #f1f5f9;
}

.pt-item-row:first-of-type {
    border-top: 0;
}

.pt-item {
    padding: 9px 14px;
    font-size: 0.8125rem;
    color: #334155;
    cursor: pointer;
    transition: background 120ms ease, color 120ms ease;
}

.pt-item:hover {
    background: var(--v2-primary-soft, rgba(8, 145, 178, 0.08));
    color: var(--v2-primary, #0891b2);
}

@media (max-width: 640px) {
    .pt-btn-lbl {
        display: none;
    }
}
</style>
